import React, { FC } from 'react'

// MUI
import { Box, CircularProgress, Container } from '@mui/material'

// UI
import { PaddTwentyFour, TypographyH6 } from '@/ui'

const LoadingSection: FC = () => {
  return (
    <Box>
      <Container maxWidth="xl">
        <PaddTwentyFour>
          <TypographyH6>
            Loading.... <CircularProgress />
          </TypographyH6>
        </PaddTwentyFour>
      </Container>
    </Box>
  )
}

export default LoadingSection
